<template>
  <div v-show="isModalVisible">
    <div class="modal-mask" @click="closeModal">
      <div class="modal-container" @click.stop v-if="loading == false">
        <div class="modal-header">
          <div class="col-11 p-0 float-left text-left heading">
            Rep Stats
          </div>
          <div class="col-1 p-0 float-right text-align-right">
            <button type="button" class="close" data-dismiss="modal" @click="closeModal">&times;</button>
          </div>
        </div>
        <div class="modal-body">

          <div class="row">
            <div class="filterBtn" style="width: 90%;">
              <div class="col-12" style="margin: 0 auto;">
                <div class="col-10" style="margin-left: 80px;">
                  <div class="col-7 p-0 float-left">
                    <div class="cp-filter-label col-5 float-left" style="width: 37%; margin-top: 20px;">Date Range:</div>
                    <b-form-select v-model="rep_days" 
                    @change="filterCompetency()"
                    :options="itemSource2" style="margin-bottom: 10px !important; margin-top: 12px;" class="col-7 float-left" />
                  </div>
                  <div class="col-5 p-0 float-left" style="margin-top: 15px; padding-bottom: 10px !important; " >
                  <div class="col-2 float-left p-0 custom-checkbox" style="padding-left: 20px !important;">
                    <input 
                      name="expand_all"
                      value="1" 
                      id="expand_all_checkbox"
                      type="checkbox"
                      class="custom-control-input"
                      v-model="expand_all"
                      @click="changeExpandAll($event)"
                      style="margin-top: 5px; margin-left: 1px;"
                      >
                      <label for="expand_all_checkbox" class="custom-control-label" style="margin-left: 30px; margin-top: 5px;"></label>
                    </div>
                    <div class="col-10 float-left p-0 bold" style="margin-top:5px; padding-left: 15px !important;">Expand All</div>
                  </div>
                </div>
                <div style="clear: both;"></div>
              </div>
            </div>
          </div>
          <div v-show="stats_loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
          <div class="report" v-if="stats_loading == false">
          <div class="row report_heading">
            <div style="width: 25%;padding-left: 5px; cursor: pointer;">
                Mentee
            </div>
            <div class="text-align-center" style="width: 15%;padding-left: 5px; cursor: pointer;">
                Competencies Earned
            </div>
            <div class="text-align-center" style="width: 15%;padding-left: 5px; cursor: pointer;">
                Reps Approved
            </div>
            <div class="text-align-center" style="width: 15%;padding-left: 5px; cursor: pointer;">
                Reps Denied
            </div>
            <div class="text-align-center" style="width: 15%;padding-left: 5px; cursor: pointer;">
                Reps Submitted
            </div>
            <div class="text-align-center" style="width: 15%;padding-left: 5px; cursor: pointer;">
                Reps to Review
            </div>
            <div class="col-12 padding-lr-5" >
                <div class="custom_heading_hr"></div>
            </div>
          </div>


          <div class="row report_view" v-for="(result,index) in mentee_lists" >
            <div class="bold" style="width: 25%;padding-left: 5px;"
            v-if="result.mentors.length == 1">
              <b-link
                v-b-toggle="'collapse-' + result.id" style="min-height: 44px; color: #002F42;"
                >
                  <u>{{ result.name }}. ({{ result.mentors.length }} Mentor)</u>
              </b-link>
            </div>
            <div class="bold" style="width: 25%;padding-left: 5px;"
            v-else>
              <b-link
                v-b-toggle="'collapse-' + result.id" style="min-height: 44px; color: #002F42;"
                >
                  <u>{{ result.name }}. ({{ result.mentors.length }} Mentors)</u>
              </b-link>
            </div>
            <div class="text-align-center"  style="width: 15%;padding-left: 5px;"
            >
              {{ result.competency_earned }}
            </div>
            <div class="text-align-center"  style="width: 15%;padding-left: 5px;"
            >
              {{ result.reps_approved }}
            </div>
            <div class="text-align-center"  style="width: 15%;padding-left: 5px;"
            >
              {{ result.reps_denied }}
            </div>
            <div class="text-align-center"  style="width: 15%;padding-left: 5px;"
            >
              {{ result.reps_submitted }}
            </div>
            <div class="text-align-center"  style="width: 15%;padding-left: 5px;"
            >
              {{ result.reps_review }}
            </div>
            <div class="col-12 p-0">
              <b-collapse :visible="result.visible" v-bind:id="'collapse-' + result.id" class="mt-2 subtask-wrapper">
                <b-card>
                  <div class="col-12 p-0" v-for="(result1,iindex) in result.mentors">
                  <div class="float-left" style="width: 25%;padding-left: 25px;" v-if="result1.inactiveflag == 1">
                    {{ result1.name }}. (Inactive)
                  </div>
                  <div class="float-left" style="width: 25%;padding-left: 25px;" v-else>
                    {{ result1.name }}.
                  </div>
                  <div class="float-left text-align-center"  style="width: 15%;padding-left: 5px;"
                  >
                    {{ result1.competency_earned }}
                  </div>                  
                  <div class="float-left text-align-center"  style="width: 15%;padding-left: 5px;"
                  >
                    {{ result1.reps_approved }}
                  </div>
                  <div class="float-left text-align-center"  style="width: 15%;padding-left: 5px;"
                  >
                    {{ result1.reps_denied }}
                  </div>
                  <div class="float-left text-align-center"  style="width: 30%;padding-left: 5px;"
                  >
                    &nbsp;
                  </div>       
                  <div style="clear: both;"></div>       
                  </div>    
                </b-card>
              </b-collapse>
            </div>
            <div class="col-12 padding-lr-5">
              <div class="custom_hr"></div>
            </div>
          </div>
          </div>




        </div>
        <div class="modal-footer" >
          <div class="col-12 p-0" >
            <div class="col-11 float-left p-0 text-center">
              <button type="submit" class="btn btn-primary btn-md start-button-blue" @click="closeModal">Close</button> 
            </div>
            <div style="margin-left: 0px; margin-top: 0px; float: right; margin-right: 0px; cursor: pointer;" class="col-1" @click="exportCSVAction()">
            <img class="" src="@/assets/Download_Report.svg" alt="MentorMentee" width="24px" />
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import router from '../../router/index.js';

export default {
    props: ['isModalVisible'],
    data() {
        return {
            loading: false,
            stats_loading: false,
            expand_all: false,
            itemSource2: [
                { value: "", text: "Select Date Range" }, 
                { value: "7", text: "Last 7 days" }, 
                { value: "15", text: "Last 15 days" },
                { value: "30", text: "Last 30 days" },
                { value: "180", text: "Last 6 Months" },
                { value: "All", text: "All Time" }
            ],
            rep_days: 180,
            mentee_lists: [],
            apiUrl: '',
            fileName: '',
        }
    },
    methods: {
        closeModal() {
          this.$emit('close');
        },
        changeExpandAll(event) {
          if(event.target.checked == true) {
            for(var i=0; i<this.mentee_lists.length; i++) {
              this.mentee_lists[i].visible = true;
            }
          }
          else {
            for(var i=0; i<this.mentee_lists.length; i++) {
              this.mentee_lists[i].visible = false;
            }
          }
        },

        exportCSVAction: function() {
          const params = {};
          
          if (this.rep_days) {
              params.days = this.rep_days;
          } else {
              params.days = '';
          }
          params.account_id = this.$store.state.user_accountid;
          params.expand_all = this.expand_all;

          axios.get('/desktop/audit-rep-stats-csv', {
              params: params
          })
          .then(response => {
            this.fileName = response.data;
            if(this.fileName) {
              this.downloadFunc();
            }
            

          })
          .catch(error => {

          });

        },
        downloadFunc: function() {
            var url = this.apiUrl + '/custom/csv-view/' + this.fileName + '/Rep-Audit';
            window.location.href = url;
            return false;
        },

        filterCompetency() {     
            const params = {};
            
            if (this.rep_days) {
                params.days = this.rep_days;
            } else {
                params.days = '';
            }
            params.account_id = this.$store.state.user_accountid;
            this.stats_loading = true;
            axios.get('/desktop/audit-rep-stats', {
                params: params
            })
            .then(response =>  {
                this.stats_loading = false;
                this.mentee_lists = response.data;
            })
            .catch(function(error) {
                console.log(error);
            });
        },

    },
    created() {
      this.filterCompetency();
      this.apiUrl = process.env.API_ENDPOINT;
    },
}
</script>
<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  transition: opacity .3s ease;
  overflow-y: hidden;
}
.modal-container {
  position: fixed;
  left: 50%;
  top: 50%;
  -ms-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 780px;
  height: 400px;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 30px;
  overflow-y: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;  
}
.modal-body {
  margin: 0px;
  padding: 0;
  overflow-y: auto;
  overflow-x: hidden;
  font-size: 16px;
}
.modal-body-h1 {
  height: 240px;
}
.modal-body-h2 {
  height: 315px;
}
.modal-footer {
  padding: 0px;
  margin: 30px 0;
  text-align: center;
  border: 0;
}
.modal-header {
  padding: 0px;
  border-bottom: 0 none;
  margin-bottom: 10px;
  margin-top: 0px;
  color: #717171;
  font-size: 15px;
}
.modal-header .close {
  padding: 5px;
  font-size: 33px;
}
.slide-title {
  font-size: 18px;
  color: #00ACEE;
  font-weight: bold;
  margin-top: 5px;
}
.item-text, .question_text {
  color: #002F42;
  font-size: 15px;
}
.assessment_title {
  color: #717171;
  font-size: 19px;
}
.link_text {
  color: #717171;
  font-weight: bold;
  font-size: 17px;
  text-decoration: underline;
}
.start-button {
  color: #29A3E4 !important;
  background-color: #FFF !important;
  border: 1px solid #29A3E4 !important;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 900;
  padding: 10px 10px 10px 10px;
  line-height: 8px;
  width: 87px;
}
.start-button-blue {
  color: #fff;
  background-color: #29A3E4 !important;
  border: 1px solid #29A3E4 !important;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 900;
  padding: 10px 10px 10px 10px;
  line-height: 8px;
  width: 87px; 
}
.angle-class {
  color: #EC511F;
  font-size: 22px;
  padding-top: 2px;
}
.heading {
  font-size: 16px;
  color: #002F42;
  font-weight: bold;
}
.filterBtn {
    display: flex;
    margin: 0 auto;
    font-size: 15px;
}
.cp-filter-label {
    font-weight: 600;
    padding: 0px;
    margin: 0 5px;
    vertical-align: middle;
}
.custom-select, .custom-select:focus {
    background-color: #e6e6e6 !important;
    border-color: #e6e6e6 !important;
    color: #707070; 
    border-radius: 20px;
}
.report_heading {    
    padding-top: 8px;
    padding-left: 15px;
    padding-right: 15px;
    padding-bottom: 8px;
    font-size: 14px;
    color: #002F42;
    font-weight: 600;
    margin-top: 20px;
}
.report_view {
  padding-left: 15px;
  padding-right: 15px;
  font-size: 14px;
  color: #002F42;
}
.custom_heading_hr, .custom_hr {
  width: 100%;
  margin: 5px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.custom_heading_hr {
    border-bottom: 3px solid rgba(0, 0, 0, 0.1);
}
.report {
  overflow-y: auto;
  overflow-x: hidden;
  height: 200px;
}
</style>



// WEBPACK FOOTER //
// src/components/manager/rep_audit_stats_modal.vue